<template>
	<az-container>
		<slot name="listagem-documentos"></slot>

		<v-divider class="mb-4"></v-divider>

		<h3 class="color-titulo font-weight-bold subtitle-1 mt-0 mb-8">Lista de Notificações</h3>

		<listagem-itens
			ref="listagemNotificacoesPenalidades"
			:textos-do-template-da-listagem-vazia="textosDaListagemVazia"
			:colunas="getColunas()"
			:itens="itensDatasource"
			:total-paginas="itensTotalPaginas"
			:total-itens="totalItens"
			:paginacao="paginacao"
			:custom-columns="['descricao']"
			@paginar="setPaginacao"
			@resetar-page="resetarPaginaListagem()"
			:tamanho-maximo-colunas="tamanhoMaximoColunas"
		>
			<template #descricao="{ item }">
				<texto-tooltip
					:texto="item.descricao || '---'"
					:tamanho-maximo="tamanhoMaximoColunas.descricao"
				></texto-tooltip>
			</template>
		</listagem-itens>
	</az-container>
</template>

<script>
import { mapState } from 'vuex'
import ListagemItens from '@/views/components/ListagemItens.vue'
import { TabelaColunaUtils } from '@/core/utils'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'
import { actionTypes } from '@/core/constants'
import TextoTooltip from '@/views/components/TextoTooltip'

export default {
	name: 'penalidade-aba-documentos',
	components: { TextoTooltip, ListagemItens },
	props: {
		entidadeTipo: {
			type: Object,
			required: true,
		},
		textosDaListagemVazia: {
			type: Object,
			required: true,
		},
		modoVisualizacao: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			paginacao: paginacaoListagem('id', 25, 'ASC'),
			itensDatasource: [],
			itensTotalPaginas: 0,
			totalItens: 0,
			tamanhoMaximoColunas: {
				descricao: 40,
				infracao: 20,
				fornecedor: 20,
				siglaOrgao: 10,
			},
		}
	},
	computed: {
		...mapState({
			orgaoSancionadorSalvo: (state) => state.penalidades.orgaoSancionadorSalvo,
			idPenalidadeSalva: (state) => state.penalidades.idPenalidadeSalva,
			fornecedorSalvo: (state) => state.penalidades.fornecedorSalvo,
			abaSelecionada: (state) => state.penalidades.abaSelecionada,
			salvarItensPenalidade: (state) => state.penalidades.salvarItensPenalidade,
		}),
	},
	watch: {
		abaSelecionada: {
			async handler() {
				if (this.abaSelecionada !== 2) return
				await this.buscarInfracoes()
			},
			immediate: true,
		},
	},
	async mounted() {
		await this.buscarInfracoes()
	},
	methods: {
		async buscarInfracoes() {
			const { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.PENALIDADES.NOTIFICACOES.BUSCAR_NOTIFICACOES_PENALIDADE,
				this.montarObjInfracoesPenalidade(),
			)

			this.itensDatasource = itens
			this.totalItens = totalElements
			this.itensTotalPaginas = totalPages
		},
		montarObjInfracoesPenalidade() {
			return {
				tipo: this.entidadeTipo,
				tipoEntidade: this.entidadeTipo.value,
				idPenalidade: this.idPenalidadeSalva,
				paginacao: this.paginacao,
			}
		},
		getColunas() {
			return [
				new TabelaColunaUtils('Infração', 'infracao', '20%'),
				new TabelaColunaUtils('Fornecedor', 'fornecedor', '20%'),
				new TabelaColunaUtils('Órgão', 'siglaOrgao', '14%'),
				new TabelaColunaUtils('Descrição', 'descricao', '36%'),
				new TabelaColunaUtils('Enviado', 'documentoEnviado', '10%'),
			]
		},
		async resetarPaginaListagem() {
			this.paginacao.page = 1
			await this.buscarInfracoes()
		},
		async setPaginacao(paginacao) {
			this.paginacao = paginacao
			await this.buscarInfracoes()
		},
	},
}
</script>

<style lang="stylus">
.color-titulo
	color: var(--v-primary-base);
</style>
